<template src="./index.html"></template>
<script>
	import data from './data.js';
export default {
	props: {
		dialogVisible_pic: {
			type: Boolean,
			default: false
		},
	},
	data() {
		return {
			 dialogFormVisible: false,
			 ruleForm: {},
			 title: {},
			 goodspage: 1, //第几页
			 goodspagenum: 10, //每页条数
			 pagenum: 10,
			 goodssearch: {
			     companyCode: '',
			     goodsCode: '',
			     goodsName: '',
			     taxRate: '',
			     unitPrice: '',
			     taxCode: '',
			     isEffective: '1' //是否有效 1:有效
			 },
			 total: '',
			 chooseallsp: '',
			 goodslikeSearch: '',
			 tableData_pic: [],
			 radio_proName: 0,
			 goodstotal: '', //总条数
		};
	},
	created() {},
	mounted() {},
	watch: {
	    dialogVisible_pic: function(indexVal, oldVal) {
			if(indexVal){
				this.chooseallsp={}
				this.page=1
				this.limit=10
				this.total=0
				this.radio_proName = 0;
				this.goodslikeSearch = '';
				this.getGoodsList()
			}
	}		
	},	
	methods: {
		addsuccess() {
		  this.radio_proName = 0;
		  this.goodslikeSearch = '';
		  this.dialogFormVisible = false;
		  this.getGoodsList()
		},
		closediag() {
		  this.dialogFormVisible = false;
		},
		/* 添加商品主数据 */
		foraddsp() {
		  this.title = "新增商品信息";
		  Object.keys(this.ruleForm).map(key => (this.ruleForm[key] = ''));
		  this.ruleForm = {
		    youhzcbz: '0',
		    shifyx: '1',
		    shuil: '0.13',
		    lingslbz: '',
		    shifkj: '1',
		    shifmr: '0',
		  }
		  this.dialogFormVisible = true;
		},
		/* 所有商品主数据列表数据搜索 */
		goodsforserchgroup() {
		    this.getGoodsList();
		},
		/* 所有商品主数据列表数据的改变 */
		handleSizeChangePro(val) {
		    this.goodspagenum = val;
		    this.getGoodsList();
		},
		handleCurrentChangePro(val) {
		    this.goodspage = val;
		    this.getGoodsList();
		},
		/* 获取商品列表数据 */
		getGoodsList() {
		    let params = {
		        page: this.goodspage,
		        limit: this.goodspagenum,
		        search: this.goodssearch,
		        likeSearch: this.goodslikeSearch,
		        sort: 'asc',
		        order: 'goodsCode',
		        userId:JSON.parse(localStorage.getItem('useropj')).id
		    };
		    this.$https.fetchPost('/master/getInvoiceGoodsList', params).then(res => {
		        for (let i=0;i<res.data.data.length;i++){
		          res.data.data[i].index=(i+1);
		        }
		        this.goodstotal = res.data.count;
		        this.tableData_pic = res.data.data;
		    });
		},
		/* 	确认选择商品主数据 */
		forsurezhuDblclick(row, column, event) {
		  this.chooseallsp = row;
		  this.$emit("forsurezhu",this.chooseallsp)
		},
		forsurezhu(){
			  this.$emit("forsurezhu",this.chooseallsp)
		},
		/* 发票选择主数据 */
		radiochangesp(val) {
		    this.chooseallsp = val;
		},
		closedialogVisible_pic(){
			this.$emit("closedialogVisible_pic",false)
		},
		forsurezhuClick(row, column, event) {
		  this.radio_proName = row.index;
		  this.chooseallsp = row;
		},
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
